export const EDIT_SUCCESS = 'Хаб обновлен';
export const EDIT_ERROR = 'Не удалось обновить хаб';
